export default __webpack_public_path__ + "static/media/lock.e688cb0c.svg";